import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const Success = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-background flex flex-col items-center justify-center p-4">
            <div className="bg-card border border-border rounded-xl p-8 max-w-md w-full text-center shadow-lg">
                <div className="w-16 h-16 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center mx-auto mb-6">
                    <Icon name="Check" size={32} className="text-green-600 dark:text-green-400" />
                </div>

                <h1 className="text-2xl font-bold text-foreground mb-2">Payment Successful!</h1>
                <p className="text-muted-foreground mb-8">
                    Thank you for your purchase. Your plan has been upgraded successfully.
                </p>

                <Button
                    fullWidth
                    onClick={() => navigate('/developer-portal')}
                >
                    Return to Dashboard
                </Button>
            </div>
        </div>
    );
};

export default Success;
